import React from 'react'
import { Form } from 'react-bootstrap'

const Group = ({
    label,
    children
}) => {
    return (
        <Form.Group>
            <Form.Label><strong>{label}</strong></Form.Label>
            {children}
        </Form.Group>
    )
}

export default Group